import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "spr-pin",
  "use": "spr-pin-usage",
  "viewBox": "0 0 313.7 426.7",
  "content": "<symbol viewBox=\"0 0 313.7 426.7\" id=\"spr-pin\">\n<style type=\"text/css\">\n\t#spr-pin .st0{fill:#FFFFFF;}\n\t#spr-pin .st1{fill:#0689FF;}\n</style>\n<path class=\"st0\" d=\"M156.9,0c-0.8,0-1.7,0-2.5,0C155.2,0,156,0,156.9,0C156.9,0,156.9,0,156.9,0z\" />\n<path class=\"st0\" d=\"M158.5,0c0.3,0,0.6,0,0.9,0C159.1,0,158.8,0,158.5,0z\" />\n<path class=\"st1\" d=\"M156.9,0C156.9,0,156.9,0,156.9,0c0.5,0,1.1,0,1.6,0C157.9,0,157.4,0,156.9,0z\" />\n<g>\n\t<circle class=\"st0\" cx=\"155.5\" cy=\"156\" r=\"92.5\" />\n\t<path class=\"st1\" d=\"M159.4,0c-0.3,0-0.6,0-0.9,0c-0.5,0-1.1,0-1.6,0c-0.8,0-1.7,0-2.5,0C68.9,1.4,0,71.1,0,156.8\n\t\tc0,36.2,13.1,68.5,32.5,95.6c124.4,174.2,124.4,174.2,124.4,174.2s0,0,124.4-174.2c19.3-27.1,32.5-59.6,32.5-95.6\n\t\tC313.7,71.1,244.9,1.4,159.4,0z M156.9,237.6c-45.3,0-82-36.7-82-82c0-1.3,0-2.7,0.1-4c2.1-43.4,37.9-78,81.9-78\n\t\tc44,0,79.8,34.6,81.9,78c0.1,1.3,0.1,2.6,0.1,4C238.8,200.9,202.1,237.6,156.9,237.6z\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ../img/sprite/pin.svg
// module id = 338
// module chunks = 0